import React, { useState, useEffect } from 'react';
import StorageManager from '../context/StorageManager';
import Swal from 'sweetalert2';
import { Modal, Form, Alert, InputGroup, Card, Spinner, Button, Tab, Nav, Row, Col } from 'react-bootstrap';
import { useProvider, Toast } from '../context/MenuProvider';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import Markdown from '../components/Utils/Markdown';
import dayjs from "dayjs";
import RenderizarItem from '../components/Utils/RenderizarProduto';
import "dayjs/locale/pt-br";

dayjs.locale("pt-br");

const Mensagens = () => {
  const [query, setQuery] = useState('');
  const { tipo, data } = useParams(); 
  const [mensagens, setMensagens] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const { setLinks, auth, site, setBtns, navigateTo, crud, setTour } = useProvider();
  const { get, loading } = crud || {};
  const navigate = useNavigate();

  useEffect(() => {
    buscarMensagens(true);
  }, [query]);

  const buscarMensagens = async (novaConaulta = false, url = `/core/mensagens-whatsapp/?tipo__in=${tipo??""}${data?`&data_criacao__date__exact=${data}`:``}${!!query?`&search=${query}`:"&ordering=-data_programada"}&expand=contato`) => {
    try {
      const response = await get(url, "mensagens");
      //alert(JSON.stringify(response))
      if (response && response[0]?.results) {
        setMensagens((prev) => novaConaulta ? [...response[0].results] : [...prev, ...response[0].results]);
        setNextUrl(response[0]?.next || null);
      } else {
        setMensagens([]);
        setNextUrl(null);
      }
    } catch (err) {
      //alert(JSON.stringify(err))
      console.error("Erro ao buscar mensagens:", err);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading && nextUrl) buscarMensagens(false, nextUrl);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, nextUrl]);

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true, mirror: false });
  }, []);
  
  const handleConfigurarCobranca = async () => {
    navigate(`/config/templates`)
  }

  useEffect(() => {
    const tour = {
        id:"mensagens_whatsapp4",
        lista:[
          {
            id: "#gvendas",
            titulo: `Tela de mensagens para WhatsApp`,
            descricao: `Aqui você ver e as mensagens programadas e enviadas no sistema ${site?.nome_curto} para o whatsapp.`,
            prev: false,
            next: true,
            finish: false
          },
          {
            id: "#programar",
            titulo: "Templates",
            descricao: "Aqui você vai para a tela de configuração dos templates e programar os horários para envios.",
            prev: false,
            next: true,
            finish: false
          },
          {
            id: "#status",
            titulo: "Status de conexção",
            descricao: "Aqui bocê ver o status de conexão do sistema com o WhatsApp.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#campo_pesquisa",
            titulo: "Campo de Pesquisa",
            descricao: "Aqui pode digitar para pesquisar por alguma mensagem.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#btn_campo_pesquisa",
            titulo: "Botão Pesquisar",
            descricao: "Botão para buscar as mensagena do campo de pesquisa.",
            prev: true,
            next: true,
            finish: false
          },
          {
            id: "#mensagens",
            titulo: "Mensagens",
            descricao: "Aqui são as mensagens enviadas e programadas no sistema.",
            prev: true,
            next: false,
            finish: true
          },
        ]
      }
    setTour(tour);
    setLinks([
      //{ name: "Novo Cliente", to: "/clientes/novo" },
    ]);
    setBtns([
      { icon: 'bx-time-five', to:`/config/templates`, id:'programar' },
    ]);
    return () => { setLinks([]); setBtns([]); };
  }, [setLinks, setBtns]);
  
  const agruparContatos = (mensagens) => {
    return Object.values(
      mensagens.reduce((acc, mensagem) => {
        const id = `${mensagem.contato.id??mensagem.contato}_${dayjs(mensagem.data_programada).format("YYYYMMDD")}`;
        if (!acc[id]) {
          acc[id] = {
            id: id,
            itens: [],
            ultimo: null,
          };
        }
  
        acc[id].itens.push(mensagem);
        acc[id].itens = acc[id].itens.sort((a, b) => a.id - b.id);
  
        // Atualiza o último com base na data_criacao
        if (
          !acc[id].ultimo ||
          new Date(mensagem.data_criacao) > new Date(acc[id].ultimo.data_criacao)
        ) {
          acc[id].ultimo = mensagem;
        }
        
        return acc;
      }, {})
    );
  };
  
  // Exemplo de uso:
  const resultado = agruparContatos(mensagens);
  //console.log(resultado);
  //alert(JSON.stringify(resultado))

  return (
    <>
      <div className="fs-4 text-center">
        <div>{auth?.empresa?.telefone_whatsapp}</div>
        <div>{auth?.empresa?.whatsapp_conectado?"Conectado":"Desconectado"}</div>
      </div>
      {!auth?.empresa?.whatsapp_conectado && (
        <div className="text-center" id="status">
          <div className="mt-3">
            <Button variant="outline-dark" onClick={()=>navigateTo("/integracao/whatsapp")}>
              <i className="bx bxl-whatsapp"></i> Conectar Whatsapp
            </Button>
          </div>
          Conecte o whatsapp para o sistema enviar as cobranças automaticamente para os clientes conforme as condigurações programadas
        </div>
      )}
                <Form>
                      <Form.Group controlId="formCobranca" className="mb-3">
                        <div className="input-group">
                          <Form.Control 
                              type="text" 
                              id="campo_pesquisa"
                              placeholder="Pesquisa..." 
                              value={query} 
                              onChange={(e) => setQuery(e.target.value)} 
                          />
                          <Button variant="secondary" id="btn_campo_pesquisa" onClick={() => buscarMensagens(true)}>
                              <i className="bi bi-search"></i>
                          </Button>
                        </div>
                      </Form.Group>
                </Form>
      <div className="list-group" id="mensagens">
        {!loading && mensagens.length === 0 && (
          <p className="text-center text-muted">Nenhum mensagem encontrado.</p>
        )}
        <div>
          {resultado.map(({ id, ultimo, itens }) => (
            <MensagemItem key={id} ultimo={ultimo} itens={itens} />
          ))}
        </div>
        {loading && <p className="text-center"><Spinner animation="border" /></p>}
      </div>
    </>
  );
};

const MensagemItem = ({ ultimo, carregarAcompanhamentos, itens }) => {
  const navigate = useNavigate();
  const [expandido, setExpandido] = useState(false);
  const [acompanhar, setAcompanhar] = useState(false);
  const [acompanhamentos, setAcompanhamentos] = useState([]);
  const [nextDownUrl, setNextDownUrl] = useState(null);
  const [loadingAcompanhamentos, setLoadingAcompanhamentos] = useState(false);
  const [dados, setDados] = useState(ultimo);
  const [loadingMais, setLoadingMais] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { crud } = useProvider();
  const { patch, post } = crud || {};

  const toggleSelecionar = async () => {
    try {
      const result = await Swal.fire({
        title: "Selecionar para apresentar?",
        text: `Selecionar ${dados?.nome} para apresentar a oportunidade de negócio?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        const response = await post(
          { 
            mensagem: dados?.id,
            observacoes:`Selecionado para apresentar o plano de negócios`,
          },
          `/rede/mensagens/`,
          null,
          "salvar"
        );
        if (response && response.length) {
          navigate(`/rede/mensagens/apresentar`);
          Toast.fire({ icon: "success", title: "Selecionado com sucesso" });
        }
      }
    } catch (err) {
      console.error("Erro ao ativar ultimo:", err);
    }
  };
  const toggleEsquecerCadastro = async () => {
    try {
      const result = await Swal.fire({
        title: `Mover para sessão "Esquecer" este Contato?`,
        text: `${dados?.cadastro?`Ao mover ${dados.nome} para sessão "Esquecer", o cadastro dele também será excluido do mapa de rede.`:`Você pode repuperar posteriormente ${dados.nome} na sessão "Esquecer"`}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        const response = await patch(
          { 
            fase: 'esquecer',
            observacoes:`Contato movido para sessão "Esquecer".`,
          },
          `/rede/mensagens/${dados?.id}/`,
          null,
          "salvar"
        );
        if (response && response.length) {
          navigate(`/rede/mensagens/esquecer`);
          Toast.fire({ icon: "success", title: "Movido com sucesso" });
        }
      }
    } catch (err) {
      console.error("Erro ao ativar ultimo:", err);
    }
  };
  const toggleAcompanharCadastro = async () => {
    try {
      const result = await Swal.fire({
        title: `Mover para sessão "Acompanhar" este Contato?`,
        text: `Ao mover ${dados.nome} para sessão "Acompanhar", ele entra no funil de acompanhamento.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        const response = await patch(
          { 
            fase: 'acompanhar',
            observacoes:`Contato movido para sessão "Acompanhar".`,
          },
          `/rede/mensagens/${dados?.id}/`,
          null,
          "salvar"
        );
        if (response && response.length) {
          navigate(`/rede/mensagens/acompanhar`);
          Toast.fire({ icon: "success", title: "Movido com sucesso" });
        }
      }
    } catch (err) {
      console.error("Erro ao ativar ultimo:", err);
    }
  };

  const toggleExpandAcompanhar = async () => {
    setShowModal(true);
  };

  const toggleExpand = async () => {
    if (!expandido && acompanhamentos.length === 0 && typeof carregarAcompanhamentos === "function") {
      setLoadingAcompanhamentos(true);
      const { results, next } = await carregarAcompanhamentos(dados.id);
      setAcompanhamentos(results);
      setNextDownUrl(next);
      setLoadingAcompanhamentos(false);
    }
    setExpandido(!expandido);
  };

  const carregarMais = async () => {
    if (!nextDownUrl || loadingMais) return;
    setLoadingMais(true);
    const { results, next } = await carregarAcompanhamentos(dados.id, nextDownUrl);
    setAcompanhamentos((prev) => [...prev, ...results]);
    setNextDownUrl(next);
    setLoadingMais(false);
  };


  const toggleCheckCadastro = async () => {
    if(dados.cadastro){
      navigate(`/rede/equipe/${dados.cadastro?.id || dados.cadastro}/editar/mensagens/`);
    } else {
      navigate(`/rede/equipe/novo/${dados?.id}/mensagens/`);
    }
  };

  const handleWhatsApp = async () => {
    const whats = (dados?.contato?.telefone)?.replace(/\D/g, '');
    if(!whats) return;
    const mensagem = encodeURIComponent(`Oi ${(dados?.contato?.nome)?.trim().split(' ')[0]}`);
    const url = `whatsapp://send?phone=+55${whats}&text=${mensagem}`;
    window.open(url);
  };
  const enviarWhatsApp = async (mensagem) => {
    mensagem = encodeURIComponent(mensagem)
    let whats = (dados?.contato?.telefone)?.replace(/\D/g, '');
    if (whats) whats = `+55${whats}`;
    const url = `whatsapp://send?phone=${whats}&text=${mensagem}`;
    window.open(url);
  };


  return (<>
    <RenderizarItem
      col="d-none"
      lm="mb-1"
      text1={(<>
        <Row>
          <Col>
            {dayjs(dados?.data_criacao).format("DD/MM/YYYY [às] HH:mm dddd")}
          </Col>
          <Col xs="auto">
            <Button onClick={()=>navigate(`/clientes/${dados.contato.cliente}`)} variant="outline-dark" size="sm" className="ms-1"><i className="bx bx-user"></i></Button>
          </Col>
        </Row>
      </>)}
      //to={`/clientes/${dados.id}`}
      titulo={`${dados?.contato?.nome}`}
      extra={(<>
        <div 
          className="ms-1 ps-1 mt-2 small" 
          style={{ borderLeft: "2px solid lightgray" }}
        >
          {itens.map((item) => (<>
            <div className="border-top pt-1">
              <Row>
                <Col xs="auto">
                  <Button onClick={()=>enviarWhatsApp(item?.mensagem)} variant={`outline-${(item.data_programada && !item.data_envio)?"danger":item.telefone?"success":"dark"}`} size="sm" className="ms-1"><i className="bx bxl-whatsapp"></i> {dados?.contato?.telefone || `WhatsApp`}</Button>
                </Col>
                <Col className="text-muted small text-end">
                  {(item.data_programada && !item.data_envio) && (<>
                    Agendada {dayjs(item.data_programada).format("DD/MM/YYYY [às] HH:mm")}
                  </>)}
                  {item.data_envio && (<>
                    Enviada {dayjs(item.data_envio).format("DD/MM/YYYY [às] HH:mm")}
                  </>)}
                </Col>
              </Row>
              <Markdown texto={item?.mensagem}></Markdown>
            </div>
          </>))}
        </div>
      </>)}
    />
  </>);
};

export default Mensagens;


